export const ROLES_ADMIN_Y_AUXILIAR = {
    "Administrador Biocontrol": "Auxiliar Biocontrol",
    "Administrador Calidad":"Auxiliar Calidad",
    "Administrador Embarques":"Auxiliar Embarques",
    "Administrador Empaque":"Auxiliar Empaque",
    "Administrador RH":"Auxiliar RH",
    "Administrador Seguridad":"Auxiliar Seguridad"
}